import { createSlice } from '@reduxjs/toolkit'
const initialState = {
    noPermissionMessage: false,
    notification: [],
    totalNotification: 0,
    // Logged-in user's role permissions, loaded from the server after login
    access: {
        loaded: false,
        isSuperAdmin: false,
        permissions: [],
    },
}

export const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        setNotification: (state, action) => {
            state.totalNotification = action.payload.totalNotification
        },
        setNoPermission: (state, action) => {
            state.noPermissionMessage = action.payload;
        },
        setAccess: (state, action) => {
            state.access = {
                loaded: true,
                isSuperAdmin: !!action.payload?.IsSuperAdmin,
                permissions: Array.isArray(action.payload?.Permissions) ? action.payload.Permissions : [],
            };
        },
    },
})

export const { setNotification, setNoPermission, setAccess } = commonSlice.actions

export default commonSlice.reducer
